import {useContext} from 'react';
import ErrorsContext from "../Context/ErrorsContext";

const useErrors = () => {
    const context = useContext(ErrorsContext);
    if (!context) {
        throw new Error('Context must be used inside a provider');
    }
    return context;
};

export default useErrors;
